import { render } from "./VideoComponent.vue?vue&type=template&id=6ecc90b7&scoped=true"
import script from "./VideoComponent.vue?vue&type=script&lang=js"
export * from "./VideoComponent.vue?vue&type=script&lang=js"

import "./VideoComponent.vue?vue&type=style&index=0&id=6ecc90b7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\steve\\swolpe-website\\website-v001\\steven-wolpe-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ecc90b7"]])

export default __exports__